// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatPage_wrapper__iiKCi {
  display: flex;
  flex-direction: row;
  padding: 32px 79px;
  border-radius: 32px;
  height: calc(100vh - 128px);
}
@media (max-width: 1024px) {
  .ChatPage_wrapper__iiKCi {
    padding: 44px 16px;
    height: calc(100vh - 120px);
  }
}

@keyframes ChatPage_slideIn__GZfpG {
  0% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(100%);
  }
}
.ChatPage_wrapperLeft__1Rdge {
  display: flex;
  flex-direction: column;
  max-width: 30%;
  gap: 32px;
  background-color: #FFFFFF;
  border-right: 1px solid #CFD6DD;
  padding-right: 20px;
  animation: ChatPage_slideIn__GZfpG 0.3s;
}

@keyframes ChatPage_slideOut__AWBNu {
  0% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(1);
  }
}
.ChatPage_wrapperLeftSmall__-itsV {
  max-width: 64px;
  animation: ChatPage_slideOut__AWBNu 0.3s;
}

.ChatPage_logoButtonWrapper__Dcegl {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.ChatPage_sidebarButton__-aqk4 {
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.ChatPage_bottomInfoContainer__iIBAn {
  display: flex;
  flex-direction: column;
  margin-top: auto;
}

.ChatPage_bottomNickContainer__ww-Aa {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ChatPage_bottomPlanContainer__Z3BEj {
  margin-top: 16px;
}

.ChatPage_avatar__0ITrF {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #C6F1DA;
}

.ChatPage_userName__EXvLu {
  margin-left: 12px;
}

.ChatPage_iconTextWrapper__DUjiB {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  color: #272E35;
}

.ChatPage_icon__ypMBw {
  margin-right: 10px;
}

.ChatPage_textWrapper__nsbBQ {
  font-weight: 700;
  font-size: 16px;
}

.ChatPage_circularProgress__PyMGP {
  margin-left: 8px;
}

.ChatPage_tabButton__uras2 {
  width: 240px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  padding: 8px 16px;
  border: none;
  background-color: #FFFFFF;
  border-radius: 8px;
  cursor: pointer;
}

.ChatPage_tabButtonSmall__asx-m {
  width: 40px;
  height: 40px;
  padding: 0;
}

.ChatPage_checkedTab__vo5a0 {
  background-color: #D8F8E7;
}

.ChatPage_tabIcon__YSiWM {
  margin-right: 16px;
}

.ChatPage_tabIconSmall__ttDry {
  margin: auto;
}

.ChatPage_wrapperRightChat__5PgG3 {
  background-color: #FCFCFD;
  width: 100%;
  padding: 24px;
}

.ChatPage_wrapperRight__Aotuo {
  background-color: #FCFCFD;
  width: 100%;
  padding: 24px;
}

.ChatPage_noChatError__cxWeH {
  display: flex;
  justify-content: center;
}

.ChatPage_extendButtonsContainer__ewDZo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: -24px;
}

.ChatPage_extendButtonsContainerSmall__xXK3H {
}

.ChatPage_extendPlanButton__3ItoT {
  border: 1px solid #C6F1DA;
  border-radius: 999px;
  background-color: transparent;
  width: 150px;
  cursor: pointer;
}

.ChatPage_extendPlanButtonSmall__Anvtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background-color: #C6F1DA;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/ChatsPage/ChatPage.module.scss","webpack://./src/styles/responsive.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;AAFJ;ACJQ;EDCR;IAQQ,kBAAA;IACA,2BAAA;EADN;AACF;;AAIA;EACI;IACI,oBAAA;EADN;EAGE;IACI,uBAAA;EADN;AACF;AAIA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;EACA,yBE9BI;EF+BJ,+BAAA;EACA,mBAAA;EACA,uCAAA;AAFJ;;AAKA;EACI;IACE,oBAAA;EAFJ;EAIE;IACE,oBAAA;EAFJ;AACF;AAKA;EAEI,eAAA;EACA,wCAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAHJ;;AAMA;EACI,6BAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBEjEO;AF8DX;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cEjGM;AF8FV;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,yBE3HI;EF4HJ,kBAAA;EACA,eAAA;AAHJ;;AAMA;EAEI,WAAA;EACA,YAAA;EACA,UAAA;AAHJ;;AAMA;EACI,yBEzHW;AFsHf;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ;;AAMA;EACI,yBEjIM;EFkIN,WAAA;EACA,aAAA;AAHJ;;AAMA;EACI,yBEvIM;EFwIN,WAAA;EACA,aAAA;AAHJ;;AAMA;EACI,aAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAHJ;;AAMA;AAFA;;AAMA;EACI,yBAAA;EACA,oBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,yBE1KO;EF2KP,eAAA;AAHJ","sourcesContent":["@use '../../styles/colors' as colors; \n@use '../../styles/responsive' as rwd; \n\n.wrapper {\n    display: flex;\n    flex-direction: row;\n    padding: 32px 79px;\n    border-radius: 32px;\n    height: calc(100vh - 128px);\n\n    @include rwd.breakpoint(small) {\n        padding: 44px 16px;\n        height: calc(100vh - 120px);\n    }\n}\n\n@keyframes slideIn {\n    0% {\n        transform: scaleX(0);\n    }\n    100% {\n        transform: scaleX(100%);\n    }\n  }\n\n.wrapperLeft {\n    display: flex;\n    flex-direction: column;\n    max-width: 30%;\n    gap: 32px;\n    background-color: colors.$white;\n    border-right: 1px solid colors.$action;\n    padding-right: 20px;\n    animation: slideIn 0.3s;\n}\n\n@keyframes slideOut {\n    0% {\n      transform: scaleX(0);\n    }\n    100% {\n      transform: scaleX(1);\n    }\n  }\n\n.wrapperLeftSmall {\n    composes: wrapperLeft;\n    max-width: 64px;\n    animation: slideOut 0.3s;\n}\n\n.logoButtonWrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.sidebarButton {\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n}\n\n.bottomInfoContainer {\n    display: flex;\n    flex-direction: column;\n    margin-top: auto;\n}\n\n.bottomNickContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.bottomPlanContainer {\n    margin-top: 16px;\n}\n\n.avatar {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background-color: colors.$greenAPP;\n}\n\n.userName {\n    margin-left: 12px;\n}\n\n.iconTextWrapper {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    text-decoration: none;\n    color: colors.$primary;\n}\n\n.icon {\n    margin-right: 10px;\n}\n\n.textWrapper {\n    font-weight: 700;\n    font-size: 16px;\n}\n\n.circularProgress {\n    margin-left: 8px;\n}\n\n.tabButton {\n    width: 240px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 0;\n    padding: 8px 16px;\n    border: none;\n    background-color: colors.$white;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.tabButtonSmall {\n    composes: tabButton;\n    width: 40px;\n    height: 40px;\n    padding: 0;\n}\n\n.checkedTab {\n    background-color: colors.$secondaryAPP;\n}\n\n.tabIcon {\n    margin-right: 16px;\n}\n\n.tabIconSmall {\n    margin: auto;\n}\n\n.wrapperRightChat {\n    background-color: colors.$surface;\n    width: 100%;\n    padding: 24px;\n}\n\n.wrapperRight {\n    background-color: colors.$surface;\n    width: 100%;\n    padding: 24px;\n}\n\n.noChatError {\n    display: flex;\n    justify-content: center;\n}\n\n.extendButtonsContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    margin-top: -24px;\n}\n\n.extendButtonsContainerSmall {\n    composes: extendButtonsContainer;\n}\n\n.extendPlanButton {\n    border: 1px solid colors.$greenAPP;\n    border-radius: 999px;\n    background-color: transparent;\n    width: 150px;\n    cursor: pointer;\n}\n\n.extendPlanButtonSmall {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: none;\n    background-color: colors.$greenAPP;\n    cursor: pointer;\n}","@mixin breakpoint($point) {\n    @if $point == small {\n        @media (max-width:  1024px) { @content; }\n    }\n    // @else if $point == medium {\n    //     @media (min-width:  769px) and (max-width: 1280px) { @content; }\n    // }\n    @else if $point == large {\n        @media (min-width:  1025px) { @content; }\n    }\n}","$white: #FFFFFF;\n\n$primary: #272E35;\n\n$grey4: #DEE3E7;\n$secondary: #555F6D;\n$whitealfa: #9E9E9E;\n$emerald5: #F4EAD7;\n$emerald7: #F8F6F1;\n\n$green0: #0EB77A;\n$green4: #08200D;\n$green5: #E1F9F0;\n\n// APP\n$secondaryAPP: #D8F8E7;\n$primaryAPP: #1D7C4D;\n$primaryGreenAPP: #086E49;\n$action: #CFD6DD;\n$surface: #FCFCFD;\n$neutral: #F5F7F9;\n$raspberry: #FBD5E2;\n$greenAPP: #C6F1DA;\n$defaultAPP: #EAEDF0;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ChatPage_wrapper__iiKCi`,
	"wrapperLeft": `ChatPage_wrapperLeft__1Rdge`,
	"slideIn": `ChatPage_slideIn__GZfpG`,
	"wrapperLeftSmall": `ChatPage_wrapperLeftSmall__-itsV ChatPage_wrapperLeft__1Rdge`,
	"slideOut": `ChatPage_slideOut__AWBNu`,
	"logoButtonWrapper": `ChatPage_logoButtonWrapper__Dcegl`,
	"sidebarButton": `ChatPage_sidebarButton__-aqk4`,
	"bottomInfoContainer": `ChatPage_bottomInfoContainer__iIBAn`,
	"bottomNickContainer": `ChatPage_bottomNickContainer__ww-Aa`,
	"bottomPlanContainer": `ChatPage_bottomPlanContainer__Z3BEj`,
	"avatar": `ChatPage_avatar__0ITrF`,
	"userName": `ChatPage_userName__EXvLu`,
	"iconTextWrapper": `ChatPage_iconTextWrapper__DUjiB`,
	"icon": `ChatPage_icon__ypMBw`,
	"textWrapper": `ChatPage_textWrapper__nsbBQ`,
	"circularProgress": `ChatPage_circularProgress__PyMGP`,
	"tabButton": `ChatPage_tabButton__uras2`,
	"tabButtonSmall": `ChatPage_tabButtonSmall__asx-m ChatPage_tabButton__uras2`,
	"checkedTab": `ChatPage_checkedTab__vo5a0`,
	"tabIcon": `ChatPage_tabIcon__YSiWM`,
	"tabIconSmall": `ChatPage_tabIconSmall__ttDry`,
	"wrapperRightChat": `ChatPage_wrapperRightChat__5PgG3`,
	"wrapperRight": `ChatPage_wrapperRight__Aotuo`,
	"noChatError": `ChatPage_noChatError__cxWeH`,
	"extendButtonsContainer": `ChatPage_extendButtonsContainer__ewDZo`,
	"extendButtonsContainerSmall": `ChatPage_extendButtonsContainerSmall__xXK3H ChatPage_extendButtonsContainer__ewDZo`,
	"extendPlanButton": `ChatPage_extendPlanButton__3ItoT`,
	"extendPlanButtonSmall": `ChatPage_extendPlanButtonSmall__Anvtn`
};
export default ___CSS_LOADER_EXPORT___;
